import { getAllSubscriptionsAction } from '../../actions/subscription'

export const subscriptionsLoader = async () => {

    await getAllSubscriptionsAction()
    return null

}